package com.patronat.top.dto.venues

import kotlinx.serialization.Serializable

@Serializable
data class VenueMediaRef(
    val mediaId: String? = null,
    val publicUrl: String? = null
)
